import { render, staticRenderFns } from "./NotifyPayment.vue?vue&type=template&id=7b308266"
import script from "./NotifyPayment.vue?vue&type=script&lang=js"
export * from "./NotifyPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports